import React from "react";
import { Container, Stack } from "react-bootstrap";
import "./Experience.css";
import Tek from "../../assets/tek.png";
import Limark from "../../assets/limark.png";
import Raciit from "../../assets/raciit.jpg"

const Experience = () => {
  return (
    <Container fluid className="experience-section" id="experience">
      <h2>
        <span>My </span> Experience
      </h2>
      <div className="experience">
        <div className="exp-one">
          <Stack className="responsive-stack" direction="horizontal" gap={3}>
            <div className="p-2">
              <img src={Tek} alt="10xtek" height={"50px"} />
            </div>
            <div className="p-2">Associate Software Engineer</div>
            <div className="p-2 ms-auto">Aug 2023 - Feb 2024</div>
          </Stack>
          <p>
            As an Associate Software Engineer at 10XTEK, I played a pivotal role
            in developing and designing websites for a diverse range of
            businesses, including restaurants, medical facilities, roofing
            companies, and towing services. Collaborating with various
            stakeholders, I created custom calculator tools tailored to the
            specific needs of roofing and towing service companies.
            Additionally, I conducted quality assurance testing on a customer
            relationship management (CRM) system to ensure optimal performance
            and user satisfaction.
          </p>
          <p>Technologies used - ReactJS, Wordpress, CNN Models, PHP</p>
        </div>
      </div>
      <br />
      <div className="experience">
        <div className="exp-one">
          <Stack direction="horizontal" gap={3}>
            <div className="p-2">
              <img src={Limark} alt="limark technologies" height={"20px"} />
            </div>
            <div className="p-2 ">Software Engineer Inter</div>
            <div className="p-2 ms-auto">Jul 2022 - Jun 2023</div>
          </Stack>
          <p>
            During my internship, I contributed to the development of a mobile
            application for a leading door lock security company, focusing on
            bug fixes and feature enhancements to improve overall functionality
            and user experience. Additionally, I assisted in the creation of a
            website for a migration web application, ensuring a seamless user
            interface. My role involved rigorous testing, debugging, and
            collaborating with the development team to address issues promptly,
            helping to deliver a polished and reliable product. I was also
            involved in developing a time entry system for the company's
            employees, streamlining their time-tracking process and improving
            operational efficiency.
          </p>
          <p>Technologies used - ReactJS, React Native, SpringBoot, MongoDB</p>
        </div>
      </div>
      <br />
      <div className="experience">
        <div className="exp-two">
          <Stack direction="horizontal" gap={3}>
            <div className="p-2">
              <img src={Raciit} alt="raciit" height={"50px"} />
            </div>
            <div className="p-2 ">Vice President</div>
            <div className="p-2 ms-auto">Jul 2022 - Jun 2023</div>
          </Stack>
          <p>
            Starting as a member of the Rotaract Club at IIT, I advanced to the
            position of IT Director and eventually became the Vice President. In
            these roles, I organized a variety of events including hackathons,
            UI/UX web design competitions, and ideathons. Additionally, I
            conducted skill enhancement sessions for school students and
            university peers. My efforts were recognized with several awards.
            Through these experiences, I honed my leadership and management
            skills, effectively coordinating and motivating club members to
            achieve our goals.
          </p>
          <p>Awards - Most Outstanding Club of the Year, Most Exceptionally Executed Professional Development Initiative, Most Outstanding Effort of using Digital Communication Technologies</p>
        </div>
      </div>
    </Container>
  );
};

export default Experience;
